
function getPageCount(total, pageSize) {
  if (typeof total === "number" && typeof pageSize === "number" && pageSize === 0) {
    throw new Error()
  }
  return Math.ceil(total / pageSize)
}

function performGetDynamicPage(pageCount) {
  const allPageList = []
  for (let i = 1; i <= pageCount; i++) {
    allPageList.push(i)
  }
  return function getDynamicPage(current) {
    if (pageCount < 5) return allPageList
    let result
    if (current <= 3) {
      result = allPageList.slice(0, 5)
    } else if (allPageList.length > 2 && current >= allPageList.length - 2) {
      result = allPageList.slice(allPageList.length - 5, allPageList.length)
    } else if (allPageList.length > 5) {
      result = allPageList.slice(current - 3, current + 2)
    } else {
      result = allPageList.slice()
    }
    return result
  }
}

let getDynamicPage = () => {}

export default {
  name: "WareViewPagination",
  props: {
    pageInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      pageConfig: {},
      curentPage: 1,
      dynamicPage: [],
      inputNum: ""
    }
  },
  computed: {},
  watch: {
    pageInfo: {
      handler(newVal) {
        this.pageConfig = newVal
      },
      immediate: true
    },
    pageConfig: {
      handler(newVal) {
        if (!newVal.pageCount) {
          newVal.pageCount = getPageCount(newVal.total, newVal.pageSize)
        }
        getDynamicPage = performGetDynamicPage(newVal.pageCount)
        this.dynamicPage = getDynamicPage(newVal.pageNum)
        this.curentPage = newVal.pageNum
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    setDynamicPage() {
      this.dynamicPage = getDynamicPage(this.curentPage)
      this.$emit("change", this.curentPage)
    },
    handleChosePage(page) {
      this.curentPage = page
      this.setDynamicPage()
    },
    handlePrev() {
      if (this.curentPage === 1) return
      this.curentPage -= 1
      this.setDynamicPage()
    },
    handleNext() {
      if (this.curentPage === this.pageConfig.pageCount) return
      this.curentPage += 1
      this.setDynamicPage()
    },
    handleGo() {
      let tmpNum = Math.round(this.inputNum)
      if (tmpNum > this.pageConfig.pageCount) tmpNum = this.pageConfig.pageCount
      if (tmpNum < 1) tmpNum = 1
      this.inputNum = tmpNum
      this.curentPage = this.inputNum
      this.setDynamicPage()
    }
  }
}
